import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleAdsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("cookieConsent") === "true") {
      // Google Tag Manager Script einfügen
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=AW-16895711428";
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", "AW-16895711428", {
        page_path: location.pathname,
      });
    }
  }, [location.pathname]);

  return null; // Keine UI-Elemente nötig
};

export default GoogleAdsTracker;
